import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import CheckoutEnjoyClub from './components/CheckoutEnjoyClub';

import CheckoutDelivery from './components/CheckoutDelivery';
import CheckoutCart from './components/CheckoutCart/CheckoutCart';
import CheckoutError from './other/CheckoutError';
import CheckoutDeliveryPickup from './components/CheckoutDeliveryPickup/CheckoutDeliveryPickup';
import CheckoutPayment from './components/CheckoutPayment/CheckoutPayment';
import { pushBeginCheckout } from './other/CheckoutAnalytics';
import { translate } from '../../Services/translation';

const Checkout = (props) => {
  const { checkout, cart, setSelectedReseller } = props || {};
  const { errors, result } = checkout || {};
  const { redirectUrl: redirect } = result || {};

  useEffect(() => {
    pushBeginCheckout({ checkout, cart });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (redirect) {
      window.location = redirect;
    }
  }, [redirect]);

  return (
    <>
      <h1 className="heading-1 mb-4 mt-8 last:mt-0">
        {translate('checkout.title')}
      </h1>

      {!cart?.orderRows?.length ? (
        <div className="checkout-section">
          <h2 className="heading-2">{translate('checkout.cart.empty')}</h2>
        </div>
      ) : (
        <>
          {!!errors?.general?.length && (
            <div className="checkout-section mb-8 last:mb-0">
              <CheckoutError errors={errors?.general} />
            </div>
          )}

          <div className="grid items-start gap-4 lg:grid-cols-5">
            <div className="lg:min-h-[calc(100svh-5rem-1rem-1rem))] lg:sticky lg:top-[calc(5rem+1rem)] lg:order-1 lg:col-span-2 lg:grid">
              <CheckoutCart checkout={checkout} cart={cart} />
            </div>

            <div className="grid gap-4 lg:col-span-3">
              <CheckoutEnjoyClub checkout={checkout} cart={cart} />

              <CheckoutDelivery checkout={checkout} />

              <CheckoutDeliveryPickup
                checkout={checkout}
                setSelectedReseller={setSelectedReseller}
              />

              <CheckoutPayment checkout={checkout} />
            </div>
          </div>
        </>
      )}
    </>
  );
};

Checkout.propTypes = {
  checkout: PropTypes.object,
  cart: PropTypes.object,
  setSelectedReseller: PropTypes.func,
};

export default Checkout;
